import React from "react";
import { Router } from "@reach/router";
import SustainMenu from "../menus/sustainMenu";
import Api from "../../common/api/api";
import SustainDetail from "./sustainDetail";

class Sustain extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      submenu: [],
      submenuAlt: [],
    };
    const menu = [];
  }
  componentDidMount() {
    this.getMenu();
  }
  getMenu = () => {
    let submenuAltArr = [];
    Api.get("/contents/getsubmenu/82").then((res) => {
      this.setState({ submenu: res.data, submenuAlt: submenuAltArr });
    });
  };

  render() {
    const data = this.state.submenu;
    return (
      <div>
        <Router>
          <SustainDetail path={"/:id"} />
        </Router>
        <SustainMenu submenu={data} />
      </div>
    );
  }
}

export default Sustain;
